import { defineComponent as _defineComponent } from 'vue';
import { CHECK, EXIT } from '@/constants/icons';
import { useResponsiveSize } from '@/use/responsiveness';
import { computed } from 'vue';
// yes, technically these numbers should never be undefined, but the problem we have
// is that some of our code isn't respecting the types correctly, so we have to defensively program here
export default /*#__PURE__*/_defineComponent({
  __name: 'table-header-selection-indicator',
  props: {
    totalSelected: {
      default: 0
    },
    totalCount: {
      default: 0
    },
    isBulkActionsAvailable: {
      type: Boolean
    },
    size: null,
    showOnlyTotal: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select-all', 'select-none'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      isXsOrSmaller
    } = useResponsiveSize(computed(() => props.size));
    return {
      __sfc: true,
      props,
      emit,
      isXsOrSmaller,
      CHECK,
      EXIT
    };
  }
});